import { render, staticRenderFns } from "./AddRoleP3.vue?vue&type=template&id=3bdaf2dd&"
import script from "./AddRoleP3.vue?vue&type=script&lang=js&"
export * from "./AddRoleP3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports